import { exact, number, string } from "prop-types";
import { Card, Heading, Separator } from "uikit/components";
import styles from "./FederationSummaryView.module.styl";
import FederationSummaryCard from "../FederationSummaryCard/FederationSummaryCard";
import { useHistory } from "react-router";
import React from "react";
import NumericalIndicatorCard from "components/common/NumericalIndicatorCard/NumericalIndicatorCard";
import { getYear, toShortDateStringLocale } from "utils";

export default function FederationSummaryView({
    currentDate,
    federationId,
    federationSummaryData,
}) {
    const history = useHistory();

    const redirectToFederationEvents = function () {
        history.push(`/federation-events/federation/${federationId}`);
    };

    const redirectToFederationLoading = function () {
        history.push(`/loading/federation/${federationId}`);
    };

    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <Heading
                size={"h2"}
                className={styles.viewHeading}
                name="federation-indicators-heading"
            >
                Показатели развития вида спорта
            </Heading>
            <Separator margin={"none"} color="grey" />
            <div className={styles.summary}>
                <FederationSummaryCard
                    dataTestName="federation_summary"
                    title={"Ежедневные данные федерации по цифровизации"}
                    descriptionText={"организаций в мониторинге"}
                    info={"Количество организаций, по которым происходит подсчёт показателей."}
                    organizationsCount={federationSummaryData.organizationsCount}
                />
            </div>
            <div className={styles.box}>
                <NumericalIndicatorCard
                    dataTestName="federation_sportsmen"
                    title={"Спортсмены"}
                    info={
                        "Количество спортсменов, занимающихся видом(-ами) спорта вашей Федерации."
                    }
                    descriptionTitle={`созданных учетных записей на ${toShortDateStringLocale(
                        currentDate,
                    )}`}
                    value={federationSummaryData.sportsmenCount}
                />
                <NumericalIndicatorCard
                    dataTestName="federation_coaches"
                    title={"Тренеры"}
                    info={
                        "Количество тренеров, осуществляющих подготовку по виду(-ам) спорта вашей Федерации."
                    }
                    descriptionTitle={`созданных учетных записей на ${toShortDateStringLocale(
                        currentDate,
                    )}`}
                    value={federationSummaryData.trainersCount}
                />
                <NumericalIndicatorCard
                    dataTestName="federation_events"
                    title={"Мероприятия"}
                    info={
                        "Количество спортивных мероприятий вашей Федерации, которые будут проводиться в текущем году."
                    }
                    descriptionTitle={`запланировано на ${getYear(currentDate)} г.`}
                    value={federationSummaryData.eventsCount}
                    onClick={redirectToFederationEvents}
                />
                <NumericalIndicatorCard
                    dataTestName="federation_places"
                    title={"Объекты спорта"}
                    info={
                        "Количество спортивных объектов региона, на которых возможно осуществлять подготовку по виду(-ам) спорта вашей Федерации."
                    }
                    descriptionTitle={`объектов инфраструктуры по виду спорта`}
                    value={federationSummaryData.sportObjectsCount}
                    onClick={redirectToFederationLoading}
                />
            </div>
        </Card>
    );
}

FederationSummaryView.propTypes = {
    currentDate: string.isRequired,
    federationId: number.isRequired,
    federationSummaryData: exact({
        organizationsCount: number.isRequired,
        sportsmenCount: number.isRequired,
        trainersCount: number.isRequired,
        eventsCount: number.isRequired,
        sportObjectsCount: number.isRequired,
    }),
};
